import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './store';  
import { BrowserRouter } from 'react-router-dom';  // Keep BrowserRouter here

const root = ReactDOM.createRoot(document.getElementById('root'));
window.getPublicUrl = (path) => {
  const base = process.env.PUBLIC_URL || '';
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return base ? `${base}${normalizedPath}` : normalizedPath;
};
root.render(
  <Provider store={store}>
    <BrowserRouter>  {/* BrowserRouter here */}
      <App />
    </BrowserRouter>
  </Provider>
);

reportWebVitals();
